export default [
  {
    title: 'Dashboard',
    route: 'dashboard',
    icon: 'HomeIcon',
    roles: ['permission.appointment.view', 'permission.calendar.teacher.view']
  }]